import { elements, html, slotted } from '@microsoft/fast-element';
import { NatGenFormField } from './form-field';

// TODO: Should tooltips be projected to a container at the provider level?
// How to project tooltip attributes onto container?

export const formFieldTemplate = html<NatGenFormField>`
    <template>
        <div>
            <slot name="validation" ${slotted({ property: 'slottedValidationNodes', filter: elements() })}></slot>
            <slot name="label" ${slotted({ property: 'slottedLabelNodes', filter: elements() })} @click="${x => x.handleLabelClick()}"></slot>
            <natgen-tooltip part="tooltip" exportparts="control:tooltip-control, title:tooltip-title, content:tooltip-content, actions:tooltip-actions" offset="[0, 8]" ?hidden="${x => x.slottedTooltipNodes?.length == 0}">
                <slot name="tooltip" ${slotted('slottedTooltipNodes')}></slot>
            </natgen-tooltip>
            <div class="control" part="control">
                <slot ${slotted({ property: 'slottedControlNodes', filter: elements() })}></slot>
            </div>
        </div>
    </template>
`;